import Card, { isDiscardLocation, isHandLocation } from "./Card";
import Color from "./Color";

export function countCardInDiscard(discard: Card[], color: Color){
    return discard.filter(card=>card.color===color && isDiscardLocation(card.location)).length
}

export function countCardInHand(allCards: Card[], color: Color){
    return allCards.filter(card=>card.color===color && isHandLocation(card.location)).length
}